import { initAnalyticsOnce, track } from "@/utils/analytics";

// 兼容历史用法：import mixpanel from "mixpanel-browser"; mixpanel.track(...)
export default {
  init(token, options) {
    initAnalyticsOnce(token, options);
  },
  track(eventName, props) {
    track(eventName, props);
  },
};

